var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1974 10.0629H11.4266L11.1533 9.81589C12.1096 8.77301 12.6853 7.4191 12.6853 5.94625C12.6853 2.66209 9.84578 0 6.34267 0C2.83957 0 0 2.66209 0 5.94625C0 9.23042 2.83957 11.8925 6.34267 11.8925C7.9137 11.8925 9.35788 11.3528 10.4703 10.4563L10.7338 10.7124V11.4351L15.6127 16L17.0667 14.6369L12.1974 10.0629ZM6.34267 10.0629C3.91294 10.0629 1.95159 8.22413 1.95159 5.94625C1.95159 3.66838 3.91294 1.82962 6.34267 1.82962C8.7724 1.82962 10.7338 3.66838 10.7338 5.94625C10.7338 8.22413 8.7724 10.0629 6.34267 10.0629Z",
    fill: "#3C91D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a55220e90a32f186b7f52c5f589343c8.svg";
export { ForwardRef as ReactComponent };